//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum EventType {
	CustomReport = 0,
	StaticReport = 1,
	Birthdays = 2,
	PlannedOperation = 3
}
